import { useMemo } from "react"

import { useGetBanners } from "utils/Banners/query"

export function useBannerSettings() {
    const { data, status } = useGetBanners()
    const { isCard, isTelegram } = useMemo(() => {
        if (status !== "success") return {}
        const isCard = data.map((banner) => banner.name).includes("card_attachment")
        const isTelegram = data.map((banner) => banner.name).includes("telegram_attachment")
        return { isCard, isTelegram }
    }, [data, status])
    return { isShowCardBanner: isCard ?? false, isShowTelegramBanner: isTelegram ?? false }
}
